import React from 'react';
import { useNavigate } from 'react-router-dom';

const SubscriptionPending = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-yellow-50 to-orange-50 p-4">
      <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 text-center">
        {/* Icono de pendiente */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Pago Pendiente ⏳
        </h2>

        <p className="text-gray-600 mb-6">
          Tu pago está siendo procesado. Te notificaremos por email cuando se acredite.
        </p>

        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4 mb-6">
          <p className="text-sm text-gray-700">
            ⏰ Los pagos pueden demorar:<br/>
            • Transferencia: 1-2 días hábiles<br/>
            • Rapipago/PagoFácil: hasta 3 días<br/>
            • Tarjeta: inmediato (usualmente)
          </p>
        </div>

        <button
          onClick={() => navigate('/dashboard/profesional')}
          className="w-full bg-gradient-to-r from-blue-500 via-cyan-500 to-green-500 text-white py-4 rounded-2xl font-bold text-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
        >
          Volver al Dashboard
        </button>

        <p className="text-center text-xs text-gray-500 mt-6">
          Revisá tu email para ver el estado del pago
        </p>
      </div>
    </div>
  );
};

export default SubscriptionPending;